import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  ActivationKeysService,
  SentActivationKeyEmailLicense,
  SentActivationKeyEmailStandaloneKey,
  SentActivationKeyEmailsHistory,
} from 'src/app/services/activation-keys.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-sent-activation-key-emails',
  templateUrl: './sent-activation-key-emails.component.html',
  styleUrl: './sent-activation-key-emails.component.scss',
})
export class SentActivationKeyEmailsComponent implements OnChanges {
  @Input() tenantId?: string;

  items: SentActivationKeyEmailsHistory[] = [];
  loading = false;
  error = '';

  collapsed = false;

  constructor(
    private activationKeysService: ActivationKeysService,
    private errorService: ErrorService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tenantId'] && this.tenantId) {
      this.load();
    }
  }

  load() {
    if (!this.tenantId) {
      return;
    }

    this.loading = true;
    this.error = '';
    this.activationKeysService
      .getSentActivationKeyEmails(this.tenantId)
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.items = res.sent_activation_key_emails ?? [];
        },
        error: (err) => {
          this.loading = false;
          this.error = this.errorService.getErrorMessage(err);
        },
      });
  }

  licenseLabel(license: SentActivationKeyEmailLicense) {
    return license.product_title || license.product_code || 'License';
  }

  standaloneKeyLabel(key: SentActivationKeyEmailStandaloneKey) {
    return key.product_title || key.product_code || 'One-off key';
  }

  displayEmailList(emails: string[]) {
    return emails.join(', ');
  }
}
